import api from "@client/content/lib/api";
import { type BlogList } from "@client/content/modules/BlogList/types";
import { type ModuleApiInfo } from "@client/content/selectors";
import { atLeastIn } from "@client/lib/misc";
import { type HttpApiResponse } from "@client/types/Api";

export default {
  getPosts: (
    apiInfo: ModuleApiInfo,
    args: BlogList.Api.GetPostsRequest
  ): Promise<HttpApiResponse<BlogList.Api.GetPostsResponse>> =>
    atLeastIn(api.get(apiInfo, `/api/site/v1/modules/blog/posts`, args), 300)
};
